import AbsoluteWindowHeightContainer from "./components/AbsoluteWindowHeightContainer.vue";
import App from "./components/App.vue";
import BreadCrumb from "./components/BreadCrumb.vue";
import Button from "./components/Button.vue";
import ButtonBar from "./components/ButtonBar.vue";
import Card from "./components/Card.vue";
import CardActions from "./components/CardActions.vue";
import CardContent from "./components/CardContent.vue";
import CardTitle from "./components/CardTitle.vue";
import Checkbox from "./components/Checkbox.vue";
import Chip from "./components/Chip.vue";
import Col from "./components/Col.vue";
import Container from "./components/Container.vue";
import DataTable from "./components/DataTable.vue";
import DatePicker from "./components/DatePicker.vue";
import Divider from "./components/Divider.vue";
import Drawer from "./components/Drawer.vue";
import DrawerItem from "./components/DrawerItem.vue";
import DrawerItemGroup from "./components/DrawerItemGroup.vue";
import DropDown from "./components/DropDown.vue";
import Editor from "./components/Editor.vue";
import Form from "./components/Form.vue";
import Input from "./components/Input.vue";
import InputAutocomplete from "./components/InputAutocomplete.vue";
import InputAutocompleteItem from "./components/InputAutocompleteItem.vue";
import InputNumber from "./components/InputNumber.vue";
import InputCurrency from "./components/InputCurrency.vue";
import InputOgm from "./components/InputOgm.vue";
import InputTime from "./components/InputTime.vue";
import Link from "./components/Link.vue";
import List from "./components/List.vue";
import ListItem from "./components/ListItem.vue";
import ListItemAction from "./components/ListItemAction.vue";
import ListItemText from "./components/ListItemText.vue";
import ListItemIcon from "./components/ListItemIcon.vue";
import Menu from "./components/Menu.vue";
import Modal from "./components/Modal.vue";
import MultiSelect from "./components/MultiSelect.vue";
import WNotification from "./components/Notification.vue";
import Pagination from "./components/Pagination.vue";
import ProgressCircular from "./components/ProgressCircular.vue";
import ProgressLinear from "./components/ProgressLinear.vue";
import Radio from "./components/Radio.vue";
import Row from "./components/Row.vue";
import ScrollPage from "./components/ScrollPage.vue";
import ScrollView from "./components/ScrollView.vue";
import Stepper from "./components/Stepper.vue";
import Select from "./components/Select.vue";
import AppSelectItem from "./components/SelectItem.vue";
import AppSelectItemList from "./components/SelectItemList.vue";
import AppSignatureCanvas from "./components/SignatureCanvas.vue";
import Sortable from "./components/Sortable.vue";
import Spacer from "./components/Spacer.vue";
import Switch from "./components/Switch.vue";
import Tab from "./components/Tab.vue";
import Tabs from "./components/Tabs.vue";
import TabsCentered from "./components/TabsCentered.vue";
import Textarea from "./components/Textarea.vue";
import TextareaAutogrow from "./components/TextareaAutogrow.vue";
import ToggleGroup from "./components/ToggleGroup.vue";
import Toolbar from "./components/Toolbar.vue";
import ToolbarItem from "./components/ToolbarItem.vue";
import ToolbarSelect from "./components/ToolbarSelect.vue";
import ToolbarText from "./components/ToolbarText.vue";
import TransitionSlideHeight from "./components/TransitionSlideHeight.vue";
import JsonViewer from "./components/JsonViewer.vue";
import SettingsGroup from "./components/SettingsGroup.vue";
import "./directives/long-touch";
import "./directives/short-click";
import "./directives/tap-touch";
import "./directives/tooltip";
import "./directives/safe-html";

import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { WinfaktVueComponentsOptions } from "./classes/install-options";
import { IWinfaktVueComponentsOptions } from "./classes/winfakt-vue-components-options";
import WfVueExtensions from "./extensions";
import Info from "./components/Info.vue";

window.addEventListener("keydown", function(e) {
	if (e.target != document.body) return;
	// space and arrow keys
	if ([32, 37, 38, 39, 40].indexOf(e.keyCode) > -1) {
		e.preventDefault();
	}
}, false);

library.add(fas);
library.add(far as any);

export const components: Array<{ name: string, component: any }> = [
	{ name: "button", component: Button },
	{ name: "app", component: App },
	{ name: "modal", component: Modal },
	{ name: "card", component: Card },
	{ name: "card-title", component: CardTitle },
	{ name: "card-content", component: CardContent },
	{ name: "card-actions", component: CardActions },
	{ name: "drawer", component: Drawer },
	{ name: "drawer-item", component: DrawerItem },
	{ name: "drawer-item-group", component: DrawerItemGroup },
	{ name: "editor", component: Editor },
	{ name: "toolbar", component: Toolbar },
	{ name: "toolbar-item", component: ToolbarItem },
	{ name: "toolbar-text", component: ToolbarText },
	{ name: "toolbar-select", component: ToolbarSelect },
	{ name: "container", component: Container },
	{ name: "col", component: Col },
	{ name: "row", component: Row },
	{ name: "input", component: Input },
	{ name: "input-autocomplete", component: InputAutocomplete },
	{ name: "input-autocomplete-item", component: InputAutocompleteItem },
	{ name: "input-number", component: InputNumber },
	{ name: "input-currency", component: InputCurrency },
	{ name: "input-ogm", component: InputOgm },
	{ name: "select", component: Select },
	{ name: "multi-select", component: MultiSelect },
	{ name: "checkbox", component: Checkbox },
	{ name: "radio", component: Radio },
	{ name: "switch", component: Switch },
	{ name: "progress-linear", component: ProgressLinear },
	{ name: "progress-circular", component: ProgressCircular },
	{ name: "spacer", component: Spacer },
	{ name: "divider", component: Divider },
	{ name: "data-table", component: DataTable },
	{ name: "pagination", component: Pagination },
	{ name: "button-bar", component: ButtonBar },
	{ name: "fa", component: FontAwesomeIcon },
	{ name: "chip", component: Chip },
	{ name: "tabs-centered", component: TabsCentered },
	{ name: "tabs", component: Tabs },
	{ name: "tab", component: Tab },
	{ name: "notification", component: WNotification },
	{ name: "list", component: List },
	{ name: "list-item", component: ListItem },
	{ name: "list-item-text", component: ListItemText },
	{ name: "list-item-action", component: ListItemAction },
	{ name: "list-item-icon", component: ListItemIcon },
	{ name: "dropdown", component: DropDown },
	{ name: "link", component: Link },
	{ name: "sortable", component: Sortable },
	{ name: "date-picker", component: DatePicker },
	{ name: "breadcrumb", component: BreadCrumb },
	{ name: "toggle-group", component: ToggleGroup },
	{ name: "textarea", component: Textarea },
	{ name: "textarea-autogrow", component: TextareaAutogrow },
	{ name: "menu", component: Menu },
	{ name: "transition-slide-height", component: TransitionSlideHeight },
	{ name: "absolute-window-height-container", component: AbsoluteWindowHeightContainer},
	{ name: "scroll-view", component: ScrollView },
	{ name: "scroll-page", component: ScrollPage },
	{ name: "input-time", component: InputTime },
	{ name: "form", component: Form},
	{ name: "select-item-list", component: AppSelectItemList},
	{ name: "select-item", component: AppSelectItem},
	{ name: "stepper", component: Stepper},
	{ name: "signature-canvas", component: AppSignatureCanvas},
	{ name: "info", component: Info},
	{ name: "json-viewer", component: JsonViewer},
	{ name: "settings-group", component: SettingsGroup}
];

export default {
	install(vue: any, options?: IWinfaktVueComponentsOptions): void {
		WinfaktVueComponentsOptions.installOptions(options || {}, vue);
		for (let comp of components) {
			vue.component("w-" + comp.name, comp.component);
		}

		vue.prototype.$wf = new WfVueExtensions();

		require("./assets/css/transitions.css");
		require("./assets/css/common.css");
		require("./assets/css/styles.css");
		require("./assets/css/grid.css");
		require("./assets/css/tooltip.css");
	}
};

export * from "./classes/index";
export * from "./utils/index";
export * from "./mixins/index";